import { useNavigate, useOutletContext } from "react-router-dom";
import styles from "./CaseStudies.module.css";
import { createScreenNavigationHandler } from "../../utils/navigationUtils";

const S3_BASE = process.env.REACT_APP_S3_BASE_URL;

const studies = [
  {
    image: `${S3_BASE}/caseStudyImage.png`,
    title: "Leading Beverage Company Enhances Web Application Performanc...",
    description: "The customer is a leading entity in the non-alcoholi...",
    path: "/beverageCaseStudy",
  },
  {
    image: `${S3_BASE}/caseStudyImage2.png`,
    title: "Is your CRM listening to your eCommerce customers?",
    description: "We harness agile methodologies and ...",
    path: "/crmListeningCaseStudy",
  },
  {
    image: `${S3_BASE}/caseStudyImage3.png`,
    title: "How do social media analytics help you grow as a business?",
    description: "We decipher uncommon industry challenges ...",
    path: "/socialMediaStudy",
  },
  {
    image: `${S3_BASE}/caseStudyImage4.png`,
    title: "Optimising your e-commerce business by reducing the loading ti...",
    description: "We combine expertise spanning software ...",
    path: "/eCommerceStudy",
  },
];

const CaseStudies = () => {
  const caseStudiesRef = useOutletContext();
  const navigate = useNavigate();
  const handleScreenNavigation = createScreenNavigationHandler(navigate);

  return (
    <section className={styles.solutionsContainer} ref={caseStudiesRef}>
      <h2 className={styles.sectionHeading}>
        Case <span className={styles.sectionHeadingHighlight}>studies</span>
      </h2>
      <div className={styles.caseStudiesContainer}>
        {studies.map((study, index) => (
          <div
            key={index}
            className={styles.caseStudyCard}
            onClick={() => handleScreenNavigation(study.path)}
          >
            <div className={styles.caseStudyImage}>
              <img src={study.image} alt={study.title} />
            </div>
            <div className={styles.caseStudyBody}>
              <h3>{study.title}</h3>
              <p>{study.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CaseStudies;
